  import React, { useEffect, useState } from 'react';
  import { useNavigate } from 'react-router-dom';
  import { getAccountsItems } from '../../services/AppService';
  import CardComponent from '../../components/CardComponent';
  import PageFade from '../../components/Login/PageFade';


  const AccountMenusPage = () => {
    const [cards, setCards] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
      const fetchData = async () => {
        const data = await getAccountsItems();
        setCards(data);
      };
      fetchData();
    }, []);

    return (
      <PageFade>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-3 justify-items-center">
          {cards.map((card, index) => (
            <CardComponent
              key={index}
              imgSrc={card.image}
              title={card.title}
              translationKey={card.translationKey}
              onClick={() => navigate(card.link)}
            />
          ))}
        </div>
      </PageFade>
    );
  };

  export default AccountMenusPage;